interface User {
  name: string;
  email: string;
}

const getUser = (): User | null => {
  if (typeof document === "undefined") return null;
  const userDataEl = document.getElementById("user-data");
  return userDataEl ? JSON.parse(userDataEl.textContent) : null;
};

export { type User, getUser };
